export default __webpack_public_path__ + "static/media/5.0ae5fcc3.jpg";